import React from 'react';
import { Tabs } from '@welbe/web-design-system';
import { Container } from './ProfilesByType.styles';
import { ListJobProfile } from '../ListJobProfile/ListJobProfile';

const tabItems = [
	{
		name: 'Gestión de perfiles',
		content: <ListJobProfile />,
	},
	/* {
		name: 'Perfiles de puesto',
	}, */
];

export const ProfilesByType = () => {
	return (
		<Container>
			<Tabs className="profile-by-type-tab" tabItems={tabItems} side="right" />
		</Container>
	);
};
